import { format } from 'date-fns'
import Papa from 'papaparse'
import encoding from 'encoding-japanese'

export default {
  // 税抜金額の税額を計算する
  getTax (price, taxRate) {
    price = price || 0
    taxRate = taxRate || 10
    // 消費税の小数点以下は切り捨て（一般的だが例外もあり）
    if (price < 0) {
      // マイナスの場合は切り上げ
      return Math.ceil(price * (taxRate / 100))
    } else {
      return Math.floor(price * (taxRate / 100))
    }
  },
  // 税抜金額から税込金額を計算する
  getIncludeTax (price, taxRate) {
    const tax = this.getTax(price, taxRate)
    return Number(price) + tax
  },
  // 税込金額から税抜金額を計算する
  getExcludeTax (inctax, taxRate) {
    inctax = inctax || 0
    taxRate = taxRate || 10
    // 消費税の小数点以下は切り捨てのため、ここでは切り上げ
    if (inctax < 0) {
      // マイナスの場合は切り捨て
      return Math.floor(inctax / ((100 + Number(taxRate)) / 100))
    } else {
      return Math.ceil(inctax / ((100 + Number(taxRate)) / 100))
    }
  },
  // 税込金額から税額を計算する
  getTaxForIncludeTax (inctax, taxRate) {
    const price = this.getExcludeTax(inctax, taxRate)
    return inctax - price
  },
  calcTimes (a, b) {
    return Number(a || 0) * Number(b || 0)
  },
  calcMinus (a, b) {
    return Number(a || 0) - Number(b || 0)
  },
  // Refer: https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
  numberWithCommas (x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  },
  // Refer: https://github.com/cfj/short-number
  shortNumber (num) {
    if (typeof num !== 'number') {
      throw new TypeError('Expected a number')
    }

    if (num > 1e19) {
      throw new RangeError('Input expected to be < 1e19')
    }

    if (num < -1e19) {
      throw new RangeError('Input expected to be > -1e19')
    }

    if (Math.abs(num) < 1000) {
      return num
    }

    const sign = num < 0 ? '-' : ''

    num = Math.abs(num)

    const suffixes = {
      K: 6,
      M: 9,
      B: 12,
      T: 16
    }
    const size = Math.floor(num).toString().length
    const exponent = size % 3 === 0 ? size - 3 : size - (size % 3)
    let shortNumber = Math.round(10 * (num / Math.pow(10, exponent))) / 10

    for (const suffix in suffixes) {
      if (exponent < suffixes[suffix]) {
        shortNumber += suffix
        break
      }
    }

    return sign + shortNumber
  },

  /*
    Ex:
    shortManNumber(0) 0万
    shortManNumber(111) 0.01万
    shortManNumber(178) 0.02万
    shortManNumber(1094) 0.11万
    shortManNumber(1999) 0.20万
    shortManNumber(1111199) 111.12万
    shortManNumber(78787878) 7878.79万
  */

  shortManNumber (num, { isSuffix = true, decimalNumber = 0 } = {}) {
    if (typeof num !== 'number') {
      throw new TypeError('Expected a number')
    }

    if (num > 1e19) {
      throw new RangeError('Input expected to be < 1e19')
    }

    if (num < -1e19) {
      throw new RangeError('Input expected to be > -1e19')
    }

    const suffix = isSuffix ? '万' : ''

    if (num > -10000 && num < 10000) return num

    if (num > 10000 && num < 100000) return (num % 10000) / 1 === 0 ? (num / 10000) + suffix : (num / 10000).toFixed(1) + suffix

    if ((num % 10000) / 1 === 0) {
      return num / 10000 + suffix
    } else {
      return (num / 10000).toFixed(decimalNumber) + suffix
    }
  },
  numberSymbolFormatter (num) {
    let negative = false
    let returnNumber = 0
    if (num < 0) {
      negative = true
    }
    const lookup = [
      { value: 1, symbol: '' },
      { value: 1e4, symbol: '万' }
    ]
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/
    var item = lookup.slice().reverse().find(function (item) {
      if (negative) {
        return -num >= item.value
      } else {
        return num >= item.value
      }
    })
    returnNumber = item ? (num / item.value).toFixed(0).replace(rx, '$1') + item.symbol : '0'
    return returnNumber
  },
  /*
  Refer: https://codezup.com/5-ways-to-convert-array-of-objects-to-object-in-javascript/
  Example:
  - input: convertArrayOfObjectToObject([{ key: '1', name: 'name 1' }], 'key')
  - output: { 1: {key: '1', name: 'name 1'} }
  */
  convertArrayOfObjectToObject (arr, key) {
    return arr.reduce((obj, item) => {
      obj[item[key]] = item
      return obj
    }, {})
  },
  formatToLocaleString (val) {
    return typeof val === 'number' ? val.toLocaleString() : 0
  },
  createFileName (name, options) {
    const { extention = 'csv' } = options || {}

    return `${name} ${format(new Date(), 'yyyyMMdd_HHmmss')}.${extention}`
  },
  convertCharacterEncodingBeforeCreateCsv (data) {
    const csv = Papa.unparse(data)
    const unicodeList = encoding.stringToCode(csv)
    const sjisArray = encoding.convert(unicodeList, 'UTF8', 'UNICODE')
    const uInt8List = new Uint8Array(sjisArray)
    const content = new Blob(
      [new Uint8Array([0xef, 0xbb, 0xbf]), uInt8List],
      { type: 'text/csv' }
    )

    return content
  },
  getUniqueListBy (arr, key) {
    return [...new Map(arr.map(item => [item[key], item])).values()]
  }
}
